import { BaseQueryParams } from "../../../../Common/QueryParamsHelper";

export class QueryParams extends BaseQueryParams
{
    public source?: "tree" | "graph";
    public root?: string;

    public serialise(propertyName: keyof QueryParams, propertyValue: any): string | null
    {
        switch (propertyName)
        {
            default:
                return super.serialise(propertyName, propertyValue);
        }
    }

    public deserialise(propertyName: keyof QueryParams, queryValue: string | null): any
    {
        switch (propertyName)
        {
            default:
                return super.deserialise(propertyName, queryValue);
        }
    }
}
